<template>
    <div
        v-if="showModal"
        :id="id"
        :class="'sammio__modal ' + (showModal ? 'sammio__modal--visible' : 'sammio__modal--hidden') + ' sammio__modal--' + getType + ' ' + getPointer"
    >
      <v-card>
        <v-card-title>
          <slot name="content"></slot>
        </v-card-title>
        <v-card-actions>
          <slot name="actions"></slot>
        </v-card-actions>
      </v-card>
    </div>
</template>

<script>
  export default {
    name: "SammioModal",
    props: {
      showModal: Boolean,
      type: String,
      pointer: String,
      id: String
    },
    computed: {
      getType: function () {
        let typeClass = 'block'
        if (this.type !== "" && this.type !== 'block') {
          typeClass = this.type
        }
        return typeClass
      },
      getPointer: function() {
        let pointerClass = ""
        if (this.pointer !== "") {
          return 'pointer--' + this.pointer
        }
        return pointerClass
      }
    }
  }
</script>
